import * as React from 'react';
import Lozenge from '@atlaskit/lozenge';

interface Props {
  status: string;
}

export const InvoiceRefundStatusLozenge = ({ status }: Props) => {
  let statusColour: 'default' | 'new' | 'moved' | 'removed' | 'success' | 'inprogress';
  switch (status) {
    case 'REFUNDED':
    case 'APPROVED':
      statusColour = 'success';
      break;
    case 'DELETED':
    case 'CC_FAILED':
    case 'CC_DECLINED':
      statusColour = 'removed';
      break;
    case 'REQUIRES_FINANCE_ACTION':
    case 'REQUIRES_APPROVAL':
    case 'FINANCE_NOTIFIED':
      statusColour = 'inprogress';
      break;
    case 'PENDING':
      statusColour = 'moved';
      break;
    case 'DENIED':
      statusColour = 'removed';
      break;
    default:
      statusColour = 'default';
  }
  return (
    <Lozenge testId={'status-lozenge'} appearance={statusColour} isBold={false}>
      {status}
    </Lozenge>
  );
};
